import moment from 'moment';

/**
 * If a moment instance is set in window, use it. Otherwise return the imported moment
 */
export const getMoment = () => window.moment || moment;
